import React, { Component } from 'react';

import Tabs from '../../UI/Tabs/Tabs';
import classes from './TabsWrapper.module.css';

export default class TabsWrapper extends Component {
  state = { activeTab: 0, currentRoute: '' };

  UNSAFE_componentWillMount () {
    if (this.props.withRouting && this.props.match) {
      const index = this.props.tabRoutes.findIndex(r => r === this.props.match.url);
      this.setState({
        activeTab: index !== -1 ? index : 0,
        currentRoute: this.props.match.url,
        historyPushed: false
      });
    } else {
      if (this.props.activeTab) {
        this.setState({activeTab: this.props.activeTab});
      } else {
        this.setState({activeTab: 0});
      }
    }
  }

  UNSAFE_componentWillReceiveProps (nextProps) {
    if (this.props.withRouting) {
      if (nextProps.match && nextProps.match.params && nextProps.match.params.tab !== this.props.match.params.tab) {
        const index = this.props.tabRoutes.findIndex(r => r === nextProps.match.url);
        this.setState({
          activeTab: index !== -1 ? index : 0,
          currentRoute: nextProps.match.url
        });
      }
    }
  }

  onTabClick = (idx) => {
    if (this.props.withRouting) {
      if (this.state.currentRoute !== this.props.tabRoutes[idx]) {
        if (this.state.historyPushed) {
          this.props.history.replace(this.props.tabRoutes[idx]);
        } else {
          this.setState({ historyPushed: true });
          this.props.history.push(this.props.tabRoutes[idx]);
        }

        this.setState({activeTab: idx, currentRoute: this.props.tabRoutes[idx]});
      }
    } else {
      if (this.props.setActiveTab && typeof this.props.setActiveTab === 'function') {
        this.props.setActiveTab(idx);
        this.setState({activeTab: idx});
      } else {
        this.setState({activeTab: idx});
      }
    }
  }

  render () {
    return (
      <div className={classes.TabsWrapper} style={this.props.style}>
        <Tabs
          onTabClick={this.onTabClick}
          tabNavTitles={this.props.tabNavTitles}
          activeTab={this.state.activeTab}
          components={this.props.components}
          dots={this.props.dots}
          squared={this.props.squared}
          tabsNavWrapperStyle={this.props.tabsNavWrapperStyle}
          tabsNavStyle={this.props.tabsNavStyle}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Layout/TabsWrapper/TabsWrapper.js